/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentManagerUserGroupBoughtResponse,
  ContentManagerUserGroupCancelResponse,
  ContentManagerUserGroupCreateResponse,
  ContentManagerUserGroupDashboardContentResponse,
  ContentManagerUserGroupIndexResponse,
  ContentManagerUserGroupSelfAssignableResponse,
  ContentManagerUserGroupShowResponse,
  ContentManagerUserGroupUpdateResponse,
  UserGroupCreate,
  UserGroupUpdate,
} from '../models';
import {
    ContentManagerUserGroupBoughtResponseFromJSON,
    ContentManagerUserGroupBoughtResponseToJSON,
    ContentManagerUserGroupCancelResponseFromJSON,
    ContentManagerUserGroupCancelResponseToJSON,
    ContentManagerUserGroupCreateResponseFromJSON,
    ContentManagerUserGroupCreateResponseToJSON,
    ContentManagerUserGroupDashboardContentResponseFromJSON,
    ContentManagerUserGroupDashboardContentResponseToJSON,
    ContentManagerUserGroupIndexResponseFromJSON,
    ContentManagerUserGroupIndexResponseToJSON,
    ContentManagerUserGroupSelfAssignableResponseFromJSON,
    ContentManagerUserGroupSelfAssignableResponseToJSON,
    ContentManagerUserGroupShowResponseFromJSON,
    ContentManagerUserGroupShowResponseToJSON,
    ContentManagerUserGroupUpdateResponseFromJSON,
    ContentManagerUserGroupUpdateResponseToJSON,
    UserGroupCreateFromJSON,
    UserGroupCreateToJSON,
    UserGroupUpdateFromJSON,
    UserGroupUpdateToJSON,
} from '../models';

export interface CompanySpacesUserGroupsBoughtGetRequest {
    kind?: CompanySpacesUserGroupsBoughtGetKindEnum;
    status?: Array<CompanySpacesUserGroupsBoughtGetStatusEnum>;
    userCount?: string;
    contentCount?: string;
    daysCount?: string;
    startDate?: string;
    term?: string;
    form?: CompanySpacesUserGroupsBoughtGetFormEnum;
    offerType?: CompanySpacesUserGroupsBoughtGetOfferTypeEnum;
    selfAssignable?: boolean;
    lecturerIds?: Array<number>;
    coordinatorIds?: Array<number>;
    billingOrders?: boolean;
    sort?: string;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesUserGroupsDashboardContentGetRequest {
    page?: number;
    perPage?: number;
}

export interface CompanySpacesUserGroupsGetRequest {
    kind?: CompanySpacesUserGroupsGetKindEnum;
    status?: Array<CompanySpacesUserGroupsGetStatusEnum>;
    userCount?: string;
    contentCount?: string;
    daysCount?: string;
    startDate?: string;
    term?: string;
    form?: CompanySpacesUserGroupsGetFormEnum;
    offerType?: CompanySpacesUserGroupsGetOfferTypeEnum;
    selfAssignable?: boolean;
    lecturerIds?: Array<number>;
    coordinatorIds?: Array<number>;
    billingOrders?: boolean;
    sort?: string;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesUserGroupsIdDeleteRequest {
    id: string;
}

export interface CompanySpacesUserGroupsIdGetRequest {
    id: string;
}

export interface CompanySpacesUserGroupsIdPutRequest {
    id: string;
    body?: UserGroupUpdate;
}

export interface CompanySpacesUserGroupsPostRequest {
    body?: UserGroupCreate;
}

export interface CompanySpacesUserGroupsUserGroupIdCancelPostRequest {
    userGroupId: number;
    body?: object;
}

/**
 * 
 */
export class UserGroupApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesUserGroupsBoughtGetRaw(requestParameters: CompanySpacesUserGroupsBoughtGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentManagerUserGroupBoughtResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.kind !== undefined) {
            queryParameters['kind'] = requestParameters.kind;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.userCount !== undefined) {
            queryParameters['user_count'] = requestParameters.userCount;
        }

        if (requestParameters.contentCount !== undefined) {
            queryParameters['content_count'] = requestParameters.contentCount;
        }

        if (requestParameters.daysCount !== undefined) {
            queryParameters['days_count'] = requestParameters.daysCount;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = requestParameters.startDate;
        }

        if (requestParameters.term !== undefined) {
            queryParameters['term'] = requestParameters.term;
        }

        if (requestParameters.form !== undefined) {
            queryParameters['form'] = requestParameters.form;
        }

        if (requestParameters.offerType !== undefined) {
            queryParameters['offer_type'] = requestParameters.offerType;
        }

        if (requestParameters.selfAssignable !== undefined) {
            queryParameters['self_assignable'] = requestParameters.selfAssignable;
        }

        if (requestParameters.lecturerIds) {
            queryParameters['lecturer_ids'] = requestParameters.lecturerIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.coordinatorIds) {
            queryParameters['coordinator_ids'] = requestParameters.coordinatorIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.billingOrders !== undefined) {
            queryParameters['billing_orders'] = requestParameters.billingOrders;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/bought`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentManagerUserGroupBoughtResponseFromJSON));
    }

    /**
     */
    async companySpacesUserGroupsBoughtGet(requestParameters: CompanySpacesUserGroupsBoughtGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentManagerUserGroupBoughtResponse>> {
        const response = await this.companySpacesUserGroupsBoughtGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsDashboardContentGetRaw(requestParameters: CompanySpacesUserGroupsDashboardContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentManagerUserGroupDashboardContentResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/dashboard_content`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentManagerUserGroupDashboardContentResponseFromJSON));
    }

    /**
     */
    async companySpacesUserGroupsDashboardContentGet(requestParameters: CompanySpacesUserGroupsDashboardContentGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentManagerUserGroupDashboardContentResponse>> {
        const response = await this.companySpacesUserGroupsDashboardContentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsGetRaw(requestParameters: CompanySpacesUserGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentManagerUserGroupIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.kind !== undefined) {
            queryParameters['kind'] = requestParameters.kind;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.userCount !== undefined) {
            queryParameters['user_count'] = requestParameters.userCount;
        }

        if (requestParameters.contentCount !== undefined) {
            queryParameters['content_count'] = requestParameters.contentCount;
        }

        if (requestParameters.daysCount !== undefined) {
            queryParameters['days_count'] = requestParameters.daysCount;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = requestParameters.startDate;
        }

        if (requestParameters.term !== undefined) {
            queryParameters['term'] = requestParameters.term;
        }

        if (requestParameters.form !== undefined) {
            queryParameters['form'] = requestParameters.form;
        }

        if (requestParameters.offerType !== undefined) {
            queryParameters['offer_type'] = requestParameters.offerType;
        }

        if (requestParameters.selfAssignable !== undefined) {
            queryParameters['self_assignable'] = requestParameters.selfAssignable;
        }

        if (requestParameters.lecturerIds) {
            queryParameters['lecturer_ids'] = requestParameters.lecturerIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.coordinatorIds) {
            queryParameters['coordinator_ids'] = requestParameters.coordinatorIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.billingOrders !== undefined) {
            queryParameters['billing_orders'] = requestParameters.billingOrders;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentManagerUserGroupIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesUserGroupsGet(requestParameters: CompanySpacesUserGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentManagerUserGroupIndexResponse>> {
        const response = await this.companySpacesUserGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsIdDeleteRaw(requestParameters: CompanySpacesUserGroupsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesUserGroupsIdDelete(requestParameters: CompanySpacesUserGroupsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesUserGroupsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesUserGroupsIdGetRaw(requestParameters: CompanySpacesUserGroupsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentManagerUserGroupShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentManagerUserGroupShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUserGroupsIdGet(requestParameters: CompanySpacesUserGroupsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentManagerUserGroupShowResponse> {
        const response = await this.companySpacesUserGroupsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsIdPutRaw(requestParameters: CompanySpacesUserGroupsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentManagerUserGroupUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/user_groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentManagerUserGroupUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUserGroupsIdPut(requestParameters: CompanySpacesUserGroupsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentManagerUserGroupUpdateResponse> {
        const response = await this.companySpacesUserGroupsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsPostRaw(requestParameters: CompanySpacesUserGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentManagerUserGroupCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/user_groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentManagerUserGroupCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUserGroupsPost(requestParameters: CompanySpacesUserGroupsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentManagerUserGroupCreateResponse> {
        const response = await this.companySpacesUserGroupsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsSelfAssignableGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentManagerUserGroupSelfAssignableResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/self_assignable`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentManagerUserGroupSelfAssignableResponseFromJSON));
    }

    /**
     */
    async companySpacesUserGroupsSelfAssignableGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentManagerUserGroupSelfAssignableResponse>> {
        const response = await this.companySpacesUserGroupsSelfAssignableGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdCancelPostRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentManagerUserGroupCancelResponse>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdCancelPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/cancel`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentManagerUserGroupCancelResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdCancelPost(requestParameters: CompanySpacesUserGroupsUserGroupIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentManagerUserGroupCancelResponse> {
        const response = await this.companySpacesUserGroupsUserGroupIdCancelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CompanySpacesUserGroupsBoughtGetKindEnum = {
    Elearning: 'elearning',
    BlendedLearning: 'blended_learning'
} as const;
export type CompanySpacesUserGroupsBoughtGetKindEnum = typeof CompanySpacesUserGroupsBoughtGetKindEnum[keyof typeof CompanySpacesUserGroupsBoughtGetKindEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsBoughtGetStatusEnum = {
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type CompanySpacesUserGroupsBoughtGetStatusEnum = typeof CompanySpacesUserGroupsBoughtGetStatusEnum[keyof typeof CompanySpacesUserGroupsBoughtGetStatusEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsBoughtGetFormEnum = {
    Online: 'online',
    Combined: 'combined',
    InPerson: 'in_person',
    InPersonAndOnline: 'in_person_and_online'
} as const;
export type CompanySpacesUserGroupsBoughtGetFormEnum = typeof CompanySpacesUserGroupsBoughtGetFormEnum[keyof typeof CompanySpacesUserGroupsBoughtGetFormEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsBoughtGetOfferTypeEnum = {
    Public: 'public',
    Private: 'private',
    None: 'none'
} as const;
export type CompanySpacesUserGroupsBoughtGetOfferTypeEnum = typeof CompanySpacesUserGroupsBoughtGetOfferTypeEnum[keyof typeof CompanySpacesUserGroupsBoughtGetOfferTypeEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsGetKindEnum = {
    Elearning: 'elearning',
    BlendedLearning: 'blended_learning'
} as const;
export type CompanySpacesUserGroupsGetKindEnum = typeof CompanySpacesUserGroupsGetKindEnum[keyof typeof CompanySpacesUserGroupsGetKindEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsGetStatusEnum = {
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type CompanySpacesUserGroupsGetStatusEnum = typeof CompanySpacesUserGroupsGetStatusEnum[keyof typeof CompanySpacesUserGroupsGetStatusEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsGetFormEnum = {
    Online: 'online',
    Combined: 'combined',
    InPerson: 'in_person',
    InPersonAndOnline: 'in_person_and_online'
} as const;
export type CompanySpacesUserGroupsGetFormEnum = typeof CompanySpacesUserGroupsGetFormEnum[keyof typeof CompanySpacesUserGroupsGetFormEnum];
/**
 * @export
 */
export const CompanySpacesUserGroupsGetOfferTypeEnum = {
    Public: 'public',
    Private: 'private',
    None: 'none'
} as const;
export type CompanySpacesUserGroupsGetOfferTypeEnum = typeof CompanySpacesUserGroupsGetOfferTypeEnum[keyof typeof CompanySpacesUserGroupsGetOfferTypeEnum];
